<!-- @format -->

<template>
    <div class="gst-support-section pb-6">
        <hr class="gst-hr" />
        <h5 class="gst-support-section__title pb-2 pt-8 pt-md-6">{{ $t('title') }}</h5>
        <p class="gst-support-section__segment">{{ $t('content1') }}</p>
        <a
            :href="helpCenterHref"
            target="_blank"
            class="gst-support-section__link"
            >{{ $t('contactUs') }}</a
        >
    </div>
</template>

<script>
import tenantUrlsConstants from '@tenant/app/utils/constants/tenantUrls';

export default {
    name: 'SupportSection',
    i18nOptions: {
        namespaces: 'main',
        keyPrefix: 'modules.hotel.features.manageBooking._components.support',
    },
    computed: {
        helpCenterHref() {
            return tenantUrlsConstants.helpCenter;
        },
        myAccountHref() {
            return tenantUrlsConstants.myAccount;
        },
        phoneNumberHref() {
            return 'tel:8552321403';
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@scssVariables';
@import '@scssMixins';

.gst-support-section {
    .gst-support-section__title,
    .gst-support-section__segment {
        color: theme-color('quaternary');
    }

    .gst-support-section__title {
        font-size: font-size('xxl');
        font-weight: font-weight('medium');
    }

    .gst-support-section__link,
    .gst-support-section__segment {
        display: inline;
        line-height: line-height('xxxl');
        font-size: font-size('s');
        font-weight: font-weight('regular');
    }

    .gst-support-section__link {
        color: theme-color('primary');
        font-weight: font-weight('large');
    }
}

@include mobile-only {
    .gst-support-section {
        .gst-support-section__title {
            font-size: font-size('s');
        }
    }
}
</style>
